export default __webpack_public_path__ + "images/15efdfaa9b4869adccdbd297040d22aa-fall_seasonal_mobile.webp";